import blog_be_body_kind from './blogs/be_body_kind.svelte';
import blog_have_a_cuppa_day_7 from './blogs/have_a_cuppa_day_7.svelte';
import blog_exam_stress_day_6 from './blogs/exam_stress_day_6.svelte';
import blog_be_aware_day_5 from './blogs/be_aware_day_5.svelte';
import blog_mantra_day_4 from './blogs/mantra_day_4.svelte';
import blog_breathing_day_3 from './blogs/breathing_day_3.svelte';
import blog_stressing_about_some_particular_problem_day_2 from './blogs/stressing_about_some_particular_problem_day_2.svelte';
import blog_get_out_in_the_garden_day_1 from './blogs/get_out_in_the_garden_day_1.svelte';
import blog_mental_health_awareness_week_14th_20th_may_2018 from './blogs/mental_health_awareness_week_14th_20th_may_2018.svelte';
import blog_so_what_do_i_do_if_my_child_is_being_bullied from './blogs/so_what_do_i_do_if_my_child_is_being_bullied.svelte';
import blog_on_naming_and_not_shaming_feelings from './blogs/on_naming_and_not_shaming_feelings.svelte';
import blog_are_you_running_out_of_ideas_to_amuse_your_kids from './blogs/are_you_running_out_of_ideas_to_amuse_your_kids.svelte';
import blog_10_ideas_for_giving_your_child_an_unforgettable_summer_holiday_without_breaking_the_bank from './blogs/10_ideas_for_giving_your_child_an_unforgettable_summer_holiday_without_breaking_the_bank.svelte';
import blog_the_chill_zone from './blogs/the_chill_zone.svelte';
import blog_quick_tip_forest_bathing_chill_skills_in_the_trees from './blogs/quick_tip_forest_bathing_chill_skills_in_the_trees.svelte';
import blog_quick_tip_are_your_children_getting_enough_sleep from './blogs/quick_tip_are_your_children_getting_enough_sleep.svelte';
import blog_quick_tip_bring_calm_to_your_body_through_breathing from './blogs/quick_tip_bring_calm_to_your_body_through_breathing.svelte';
import blog_quick_tip_get_into_a_flow_activity_to_calm_your_mind from './blogs/quick_tip_get_into_a_flow_activity_to_calm_your_mind.svelte';
import blog_quick_tip_inner_strength_from_holding_a_stone from './blogs/quick_tip_inner_strength_from_holding_a_stone.svelte';
import blog_quick_tip_the_bodys_natural_stress_reliever_crying from './blogs/quick_tip_the_bodys_natural_stress_reliever_crying.svelte';
import blog_quick_tip_are_you_having_a_laugh from './blogs/quick_tip_are_you_having_a_laugh.svelte';
import blog_thinking_of_a_screen_time_ban_for_your_child from './blogs/thinking_of_a_screen_time_ban_for_your_child.svelte';
import blog_a_dog_a_kids_best_friend from './blogs/a_dog_a_kids_best_friend.svelte';
import blog_bully_culture from './blogs/bully_culture.svelte';
import blog_why_is_my_child_always_getting_sick from './blogs/why_is_my_child_always_getting_sick.svelte';
import blog_on_childrens_strikes_to_protect_their_mental_health from './blogs/on_childrens_strikes_to_protect_their_mental_health.svelte';
import blog_on_being_too_nice from './blogs/on_being_too_nice.svelte';
import blog_on_sensitivity_and_toughening_up from './blogs/on_sensitivity_and_toughening_up.svelte';
import blog_parenting_a_sensitive_child from './blogs/parenting_a_sensitive_child.svelte';

export default [
    {
        id: 'be-body-kind',
        old_id: '20may2019',
        title: 'Be body kind!!',
        date: '20 May 2019',
        abstract: 'Both young and old, tall and small, fat and thin…. we are all quite conscious of our bodies. There...',
        image: '/images/blogs/bodyimage hair.jpg',
        author: 'Alison Williamson',
        path: './blogs/be_body_kind.svelte',
        component: blog_be_body_kind,
        tags: []
    },
    {
        id: 'have-a-cuppa-day-7',
        old_id: '20may2018',
        title: 'Have a cuppa - Day 7',
        date: '20 May 2018',
        abstract: 'Drinking water can really help to keep you healthy and de-stressed.  The body consist of 75% water,...',
        image: '/images/blogs/glassofwater.jpg',
        author: 'Alison Williamson',
        path: './blogs/have_a_cuppa_day_7.svelte',
        component: blog_have_a_cuppa_day_7,
        tags: []
    },
    {
        id: 'exam-stress-day-6',
        old_id: '19may2018',
        title: 'Exam Stress Day 6',
        date: '19 May 2018',
        abstract: 'Kids doing important exams just now are usually prone to stress. So how can you help your child to...',
        image: '/images/blogs/exam.jpg',
        author: 'Alison Williamson',
        path: './blogs/exam_stress_day_6.svelte',
        component: blog_exam_stress_day_6,
        tags: []
    },
    {
        id: 'be-aware-day-5',
        old_id: '18may2018',
        title: 'Be Aware - Day 5',
        date: '18 May 2018',
        abstract: 'Being self-aware or being aware that your children are stressed is a positive as you can take actio...',
        image: '/images/blogs/rest.jpg',
        author: 'Alison Williamson',
        path: './blogs/be_aware_day_5.svelte',
        component: blog_be_aware_day_5,
        tags: []
    },
    {
        id: 'mantra-day-4',
        old_id: '17may2018',
        title: 'Mantra - Day 4',
        date: '17 May 2018',
        abstract: 'Saying mantras can conjure up an image of a hippy sitting cross legged on the floor surrounded by i...',
        image: '/images/blogs/sleeping puppies.jpg',
        author: 'Alison Williamson',
        path: './blogs/mantra_day_4.svelte',
        component: blog_mantra_day_4,
        tags: []
    },
    {
        id: 'breathing-day-3',
        old_id: '16may2018',
        title: 'Breathing - Day 3',
        date: '16 May 2018',
        abstract: 'A popular way to de-stress is to focus on your breathing. By focusing on basic automatic body funct...',
        image: '/images/blogs/breathe.jpg',
        author: 'Alison Williamson',
        path: './blogs/breathing_day_3.svelte',
        component: blog_breathing_day_3,
        tags: []
    },
    {
        id: 'stressing-about-some-particular-problem-day-2',
        old_id: '15may2018',
        title: 'Stressing about some particular problem - Day 2',
        date: '15 May 2018',
        abstract: 'Try this and see if it makes you less stressed So you have an issue that has been bugging you all d...',
        image: '/images/blogs/film.jpg',
        author: 'Alison Williamson',
        path: './blogs/stressing_about_some_particular_problem_day_2.svelte',
        component: blog_stressing_about_some_particular_problem_day_2,
        tags: []
    },
    {
        id: 'get-out-in-the-garden-day-1',
        old_id: '14may2018',
        title: 'Get out in the Garden -  Day 1',
        date: '14 May 2018',
        abstract: 'Gardening is one of the top activities to help de-stress! It is a really good activity as it can so...',
        image: '/images/blogs/carrot.jpg',
        author: 'Alison Williamson',
        path: './blogs/get_out_in_the_garden_day_1.svelte',
        component: blog_get_out_in_the_garden_day_1,
        tags: []
    },
    {
        id: 'mental-health-awareness-week-14th-20th-may-2018',
        old_id: '13may2018',
        title: 'Mental Health Awareness Week 14th – 20th May 2018.',
        date: ' 13 May 2018',
        abstract: 'Once again the Skill Tree Company is supporting Mental Health Awareness Week. The focus this year i...',
        image: '/images/blogs/stresspencil.jpg',
        author: 'Alison Williamson',
        path: './blogs/mental_health_awareness_week_14th_20th_may_2018.svelte',
        component: blog_mental_health_awareness_week_14th_20th_may_2018,
        tags: []
    },
    {
        id: 'so-what-do-i-do-if-my-child-is-being-bullied',
        old_id: '12may2018',
        title: 'So what do I do if my child is being bullied?',
        date: '12 May 2018',
        abstract: 'Firstly, if you have a highly sensitive child or a child who is a bit different in some way or anot...',
        image: '/images/blogs/bullyiedchild.jpg',
        author: 'Alison Williamson',
        path: './blogs/so_what_do_i_do_if_my_child_is_being_bullied.svelte',
        component: blog_so_what_do_i_do_if_my_child_is_being_bullied,
        tags: []
    },
    {
        id: 'on-naming-and-not-shaming-feelings',
        old_id: '11march2018',
        title: 'On naming (and not shaming) feelings',
        date: '11 March 2018',
        abstract: 'Remember when your child was a tantrum throwing  toddler and you would have no choice but to helple...',
        image: '/images/logo.png',
        author: 'Judith Algar Nicholas',
        path: './blogs/on_naming_and_not_shaming_feelings.svelte',
        component: blog_on_naming_and_not_shaming_feelings,
        tags: []
    },
    {
        id: 'are-you-running-out-of-ideas-to-amuse-your-kids',
        old_id: '13august2017',
        title: 'Are you running out of ideas to amuse your kids?',
        date: '13 August 2017',
        abstract: 'Are you still having fun with your kids with loads of ideas still in reserve of how to keep them am...',
        image: '/images/blogs/traveler.jpg',
        author: 'Judith Algar Nicholas',
        path: './blogs/are_you_running_out_of_ideas_to_amuse_your_kids.svelte',
        component: blog_are_you_running_out_of_ideas_to_amuse_your_kids,
        tags: []
    },
    {
        id: '10-ideas-for-giving-your-child-an-unforgettable-summer-holiday-without-breaking-the-bank',
        old_id: '15july2017',
        title: '10 ideas for giving your child an unforgettable summer holiday – without breaking the bank.',
        date: '15 July 2017',
        abstract: 'The long summer holidays stretch ahead, and whilst you`re happy at the prospect of freedom from the...',
        image: '/images/blogs/summer.jpg',
        author: 'Judith Algar Nicholas',
        path: './blogs/10_ideas_for_giving_your_child_an_unforgettable_summer_holiday_without_breaking_the_bank.svelte',
        component: blog_10_ideas_for_giving_your_child_an_unforgettable_summer_holiday_without_breaking_the_bank,
        tags: []
    },
    {
        id: 'the-chill-zone',
        old_id: '19may2017',
        title: 'The Chill Zone',
        date: '19 May 2017',
        abstract: 'In very hot sunny weather The Skill Tree Company provided some Chill with our Chill Zone at the Uni...',
        image: '/images/blogs/stones2.jpg',
        author: 'Alison Williamson',
        path: './blogs/the_chill_zone.svelte',
        component: blog_the_chill_zone,
        tags: []
    },
    {
        id: 'quick-tip-forest-bathing-chill-skills-in-the-trees',
        old_id: '14may2017',
        title: 'Quick Tip - Forest Bathing - chill skills in the trees!',
        date: '14 May 2017',
        abstract: 'Our tip for Sunday is to get outside into the greenery and be close to trees!! There is a Japanese...',
        image: '/images/blogs/tree.jpg',
        author: 'Alison Williamson',
        path: './blogs/quick_tip_forest_bathing_chill_skills_in_the_trees.svelte',
        component: blog_quick_tip_forest_bathing_chill_skills_in_the_trees,
        tags: []
    },
    {
        id: 'quick-tip-are-your-children-getting-enough-sleep',
        old_id: '13may2017',
        title: 'Quick Tip - Are your children getting enough sleep?',
        date: '13 May 2017',
        abstract: 'Tip for the weekend as this may be a time when a child … and adults can catch up on sleep from the...',
        image: '/images/blogs/children.jpg',
        author: 'Alison Williamson',
        path: './blogs/quick_tip_are_your_children_getting_enough_sleep.svelte',
        component: blog_quick_tip_are_your_children_getting_enough_sleep,
        tags: []
    },
    {
        id: 'quick-tip-bring-calm-to-your-body-through-breathing',
        old_id: '12may2017',
        title: 'Quick Tip - Bring calm to your body through breathing',
        date: '12 May 2017',
        abstract: 'How can we chill?<br/> First step. Breathing?<br/> Test yourself. Lie or sit comfortably and count...',
        image: '/images/blogs/woman.jpg',
        author: 'Alison Williamson',
        path: './blogs/quick_tip_bring_calm_to_your_body_through_breathing.svelte',
        component: blog_quick_tip_bring_calm_to_your_body_through_breathing,
        tags: []
    },
    {
        id: 'quick-tip-get-into-a-flow-activity-to-calm-your-mind',
        old_id: '11may2017',
        title: 'Quick Tip - Get into a \"flow\" activity to calm your mind.',
        date: '11 May 2017',
        abstract: 'Flow activities Another way of distracting our brains from the constant interaction of so many thou...',
        image: '/images/blogs/relay-race.jpg',
        author: 'Alison Williamson',
        path: './blogs/quick_tip_get_into_a_flow_activity_to_calm_your_mind.svelte',
        component: blog_quick_tip_get_into_a_flow_activity_to_calm_your_mind,
        tags: []
    },
    {
        id: 'quick-tip-inner-strength-from-holding-a-stone',
        old_id: '10may2017',
        title: 'Quick Tip - Inner strength from holding a stone.',
        date: '10 May 2017',
        abstract: 'Connecting with something for inner strength. Babies and toddlers often carry a soother or small bl...',
        image: '/images/blogs/rock.jpg',
        author: 'Alison Williamson',
        path: './blogs/quick_tip_inner_strength_from_holding_a_stone.svelte',
        component: blog_quick_tip_inner_strength_from_holding_a_stone,
        tags: []
    },
    {
        id: 'quick-tip-the-bodys-natural-stress-reliever-crying',
        old_id: '09may2017',
        title: 'Quick Tip - The body\'s natural stress reliever - crying!',
        date: '09 May 2017',
        abstract: 'Have a clear out of pent up emotions – crying can be good for us! This is something to remember, fo...',
        image: '/images/blogs/child.jpg',
        author: 'Alison Williamson',
        path: './blogs/quick_tip_the_bodys_natural_stress_reliever_crying.svelte',
        component: blog_quick_tip_the_bodys_natural_stress_reliever_crying,
        tags: []
    },
    {
        id: 'quick-tip-are-you-having-a-laugh',
        old_id: '08may2017',
        title: 'Quick Tip - Are you having a laugh?',
        date: '08 May 2017',
        abstract: 'Laugh out loud ! Try watching a comedy program, read a funny book, watch a cartoon or get some frie...',
        image: '/images/blogs/girl.jpg',
        author: 'Alison Williamson',
        path: './blogs/quick_tip_are_you_having_a_laugh.svelte',
        component: blog_quick_tip_are_you_having_a_laugh,
        tags: []
    },
    {
        id: 'thinking-of-a-screen-time-ban-for-your-child',
        old_id: '04february2017',
        title: 'Thinking of a screen time ban for your child?',
        date: '04 February 2017',
        abstract: 'Here’s 10 things you should try first.  If you’re disturbed by the amount of time your child is spen...',
        image: '/images/blogs/ptoymp.jpg',
        author: 'Judith Algar Nicholas',
        path: './blogs/thinking_of_a_screen_time_ban_for_your_child.svelte',
        component: blog_thinking_of_a_screen_time_ban_for_your_child,
        tags: []
    },
    {
        id: 'a-dog-a-kids-best-friend',
        old_id: '12november2016',
        title: 'A Dog - a kid\'s best friend!',
        date: '12 November 2016',
        abstract: 'All children and teenagers appreciate a sense of security, someone that is always there for them whe...',
        image: '/images/blogs/dog1.jpg',
        author: 'Alison Williamson',
        path: './blogs/a_dog_a_kids_best_friend.svelte',
        component: blog_a_dog_a_kids_best_friend,
        tags: []
    },
    {
        id: 'bully-culture',
        old_id: '24semptember2016',
        title: 'Bully Culture',
        date: '24 Semptember 2016',
        abstract: '<b>Are we raising our children in a society which sees bullying as entertainment?</b> When my first...',
        image: '/images/blogs/child-tv.jpg',
        author: 'Judith Algar Nicholas',
        path: './blogs/bully_culture.svelte',
        component: blog_bully_culture,
        tags: []
    },
    {
        id: 'why-is-my-child-always-getting-sick',
        old_id: '31july2016',
        title: 'Why is my child always getting sick?',
        date: '31 July 2016',
        abstract: 'We are all familiar with the first signs. Sometime around October, or even sooner if we are unlucky...',
        image: '/images/blogs/teddies.jpg',
        author: 'Judith Algar Nicholas',
        path: './blogs/why_is_my_child_always_getting_sick.svelte',
        component: blog_why_is_my_child_always_getting_sick,
        tags: []
    },
    {
        id: 'on-childrens-strikes-to-protect-their-mental-health',
        old_id: '07may2016',
        title: 'On Children\'s strikes to protect their mental health',
        date: '07 May 2016',
        abstract: '<strong>… to test or not to test!</strong>  So parents across the country this week withdrew their...',
        image: '/images/blogs/boy-and-book.jpg',
        author: 'Judith Algar Nicholas',
        path: './blogs/on_childrens_strikes_to_protect_their_mental_health.svelte',
        component: blog_on_childrens_strikes_to_protect_their_mental_health,
        tags: []
    },
    {
        id: 'on-being-too-nice',
        old_id: '19march2016',
        title: 'On being \'too nice\'',
        date: '19 March 2016',
        abstract: 'Has your child ever been told they are just ‘too nice’? Have you? Have you ever wondered what that r...',
        image: '/images/blogs/child-close.jpg',
        author: 'Judith Algar Nicholas',
        path: './blogs/on_being_too_nice.svelte',
        component: blog_on_being_too_nice,
        tags: []
    },
    {
        id: 'on-sensitivity-and-toughening-up',
        old_id: '14february2016',
        title: 'On Sensitivity and \"Toughening Up\"',
        date: '14 February 2016',
        abstract: 'Here at The Skill Tree Company we know that a very common experience for sensitive children (and in...',
        image: '/images/blogs/child-portrait.jpg',
        author: 'Judith Algar Nicholas',
        path: './blogs/on_sensitivity_and_toughening_up.svelte',
        component: blog_on_sensitivity_and_toughening_up,
        tags: []
    },
    {
        id: 'parenting-a-sensitive-child',
        old_id: '30january2016',
        title: 'Parenting a Sensitive child',
        date: '30 January 2016',
        abstract: 'For many years I did not know I was raising a highly sensitive child. I only knew I was doing paren...',
        image: '/images/blogs/hands.jpg',
        author: 'Judith Algar Nicholas',
        path: './blogs/parenting_a_sensitive_child.svelte',
        component: blog_parenting_a_sensitive_child,
        tags: []
    },/**/
]